




















































import Vue from 'vue';
import moment from 'moment';
import {
  api,
  REGISTRATION_API_URL,
  MEMBER_API_SUB_URLS,
} from '@/api';
import { pick } from 'lodash';
import {
  CloseFullscreenWrapper,
  CloseStepperWrapper,
  AWSAuthAPI,
} from '@/mixins';
import { EventBus } from '@/event-bus';
import { ExtendMixins } from '@/services';
import { get } from 'lodash';
import {
  RegistrationIdentityFormModel,
  RegistrationEmailFormModel,
  RegistrationCredentialsFormModel,
  StepperSteps,
} from '@/@types/member';
import { StepperWrapper } from '@/components/stepper-wrapper-component';
import RegisterStep1 from './register-step-1.component.vue';
import RegisterStep2 from './register-step-2.component.vue';
import RegisterStep3Email from './register-step-3-email.component.vue';
import RegisterStep3Credentials from './register-step-3-credentials.component.vue';

interface Data {
  currentStepPosition: number;
  formValid: boolean;
  memberHasEmail: boolean;
  registrationIdentity: RegistrationIdentityFormModel;
  registrationEmail: RegistrationEmailFormModel;
  registrationCredentials: RegistrationCredentialsFormModel;
  steps: StepperSteps[];
  memberId: string;
  error: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  CloseStepperWrapper,
  AWSAuthAPI,
).extend({
  name: 'Register',
  data(): Data {
    return {
      currentStepPosition: 1,
      formValid: false,
      memberHasEmail: false,
      registrationIdentity: {
        saId: '',
        dateOfBirth: '',
        last4SSN: '',
      },
      registrationEmail: {
        emailAddress: '',
      },
      registrationCredentials: {
        username: '',
        password: '',
        terms: false,
      },
      steps: [],
      memberId: '',
      error: '',
    };
  },
   created() {
    this.$set(this, 'steps', [
        {
          ref: 'step1',
          name: 'register-step-1-label',
          showBack: false,
          isCompleted: false,
          isEditable: false,
          stepPosition: 1,
          isLoading: false,
          isSubmitting: false,
          isError: false,
        },
        {
          ref: 'step2',
          name: 'register-step-2-label',
          showBack: true,
          isCompleted: false,
          isEditable: false,
          stepPosition: 2,
          isLoading: false,
          isSubmitting: false,
          isError: false,
        },
        {
          ref: 'step3',
          name: 'register-step-3-label',
          showBack: false,
          isCompleted: false,
          isEditable: false,
          stepPosition: 3,
          isLoading: false,
          isSubmitting: false,
          isError: false,
        },
    ]);
  },
  computed: {
    currentStep(): StepperSteps {
      return this.steps[this.currentStepPosition - 1];
    },
  },
  props: {
    brand: {
      type: String,
      required: true,
    },
  },
  components: {
    StepperWrapper,
    RegisterStep1,
    RegisterStep2,
    RegisterStep3Email,
    RegisterStep3Credentials,
  },
  methods: {
    nextStep(): void {
      if (this.currentStepPosition < this.steps.length) {
        this.currentStep.isCompleted = true;
        this.currentStep.isSubmitting = false;
        this.setStep(this.currentStepPosition + 1);
      }
    },
    previousStep(): void {
      if (this.currentStepPosition > 1) {
        this.setStep(this.currentStepPosition - 1);
      }
    },
    setStep(step): void {
      this.currentStepPosition = step;
      this.currentStep.isCompleted = false;
      this.currentStep.isSuccess = false;
    },
    submitRegistrationAccountID(): void {
      this.currentStep.isSubmitting = true;
      this.nextStep();
    },

    async submitRegistrationIdentity(captchaToken) {
      this.currentStep.isSubmitting = true;
      api.defaults.headers['x-captcha-token'] = captchaToken;
      api
        .post(`${REGISTRATION_API_URL}/registration-credentials`,
          {
            saId: `SA${this.registrationIdentity.saId}`,
            dateOfBirth: moment(this.registrationIdentity.dateOfBirth, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            last4SSN: this.registrationIdentity.last4SSN,
          },
        )
        .then(async (response: any) => {
          this.memberId = response.data.member.memberId;
          this.setAwsCredentials(
            response.data.credentials.SecretAccessKey,
            response.data.credentials.AccessKeyId,
            response.data.credentials.SessionToken,
          );
          await this.getEmailIndicator();
        })
        .catch((error) => {
          this.currentStep.isSubmitting = false;
          this.currentStep.isError = true;
        });
    },

    async getEmailIndicator() {
      this.awsRequest(
        'GET',
        `${MEMBER_API_SUB_URLS.members}/${this.memberId}/registration-email-indicators`,
      ).then((response: any) => {
          if (response.data.hasEmailIndicator) {
            this.memberHasEmail = true;
          } else {
            this.memberHasEmail = false;
          }
          this.currentStep.isSubmitting = false;
          this.nextStep();
        })
        .catch((error) => {
          this.currentStep.isSubmitting = false;
          this.currentStep.isError = true;
        });
    },

    async submitRegistrationEmail(email) {
      this.currentStep.isSubmitting = true;
      this.registrationEmail.emailAddress = email;
      this.awsRequest(
        'PUT',
        `${MEMBER_API_SUB_URLS.members}/${this.memberId}/registration-email-addresses`,
        this.registrationEmail,
      ).then((response: any) => {
          this.currentStep.isSubmitting = false;
          this.memberHasEmail = true;
        })
        .catch((error) => {
          this.currentStep.isSubmitting = false;
          this.currentStep.isError = true;
        });
    },

    async submitRegistrationCredentials() {
      this.currentStep.isSubmitting = true;
      this.awsRequest(
        'POST',
        `${REGISTRATION_API_URL}/members/${this.memberId}/registrations`,
        this.registrationCredentials,
      ).then(() => {
          this.currentStep.isSubmitting = false;
          this.currentStep.isSuccess = true;
        })
        .catch((error) => {
          this.currentStep.isSubmitting = false;
          this.currentStep.isError = true;
          this.error = get(error.response, 'data.userMessage') || get(error.response, 'data.message');
        });
    },

  },
});
